import ScalarIconDiscordLogo_vue_vue_type_script_setup_true_lang_default from "./ScalarIconDiscordLogo.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarIconDiscordLogo.vue
var ScalarIconDiscordLogo_default = ScalarIconDiscordLogo_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconDiscordLogo_default as default };

//# sourceMappingURL=ScalarIconDiscordLogo.js.map